import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, filter, takeUntil } from 'rxjs';
import { globalVar } from 'src/app/shared/global_variables';
import { environment } from 'src/environments/environment';
import { DWSMDashboardEntry } from '../models/DWSMDashboardEntry';
import { DWSMParams } from '../models/DWSMParams';
import { selectIsToCancelUpload } from '../state/dwsm.selectors';
import { Store } from '@ngrx/store';
import { DWSMJob } from '../models/DWSMJob';
import { ResponseStatusAndTaskLengthByJobId } from 'src/app/dwsm/models/ResponseStatusAndTaskLengthByJobId';

export const DWSM_JOB = '/dwsmJob';
export const GET_DWSM_DASHBOARD = '/getDwsmDashboard';
export const GET_DWSM_LITE_DASHBOARD = '/getDwsmLiteDashboard';
export const GET_DWSM_TMO_DASHBOARD = '/getDwsmTmoDashboard';
export const DELETE_DWSM_JOB_BY_ID = '/deleteJob/';
export const GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID = '/getStatusAndTaskLengthByJobId';
export const UPLOAD_DWSM = '/uploadDWSM';
export const UPDATE_JOB_TO_FINISHED = '/updateDwsmJobToFinished';
export const GET_JOB_BY_ID = '/getJobById';

@Injectable({
    providedIn: 'root'
})
export class DWSMJobService {
    constructor(private readonly httpClient: HttpClient, private readonly store: Store) {}

    public getDwsmDashboard(): Observable<DWSMDashboardEntry[]> {
        return this.httpClient.get<DWSMDashboardEntry[]>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + GET_DWSM_DASHBOARD);
    }

    public getDwsmLiteDashboard(): Observable<DWSMDashboardEntry[]> {
        return this.httpClient.get<DWSMDashboardEntry[]>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + GET_DWSM_LITE_DASHBOARD);
    }

    public getDwsmTmoDashboard(): Observable<DWSMDashboardEntry[]> {
        return this.httpClient.get<DWSMDashboardEntry[]>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + GET_DWSM_TMO_DASHBOARD);
    }

    public deleteDwsmJobById(dwsmJobId: number): Observable<number> {
        return this.httpClient.delete<number>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + DELETE_DWSM_JOB_BY_ID + dwsmJobId);
    }

    public getDWSMStatusAndTaskLengthByJobId(jobId: number): Observable<ResponseStatusAndTaskLengthByJobId> {
        return this.httpClient.get<ResponseStatusAndTaskLengthByJobId>(
            environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + GET_STATUS_AND_TASK_LENGTH_BY_JOB_ID + '/' + jobId
        );
    }

    public uploadDWSM(files: File[], params: DWSMParams): Observable<DWSMJob> {
        const formData = new FormData();
        for (const file of files) {
            formData.append('file', file, file.name);
        }
        formData.append('params', JSON.stringify(params));
        const endpoint = DWSM_JOB + UPLOAD_DWSM;
        return this.httpClient
            .post<DWSMJob>(`${environment.baseUrl}${globalVar.requestPrefix}${endpoint}`, formData)
            .pipe(takeUntil(this.store.select(selectIsToCancelUpload).pipe(filter(cancelUpload => cancelUpload === true))));
    }

    public updateDwsmJobToFinished(jobId: number): Observable<number> {
        return this.httpClient.post<number>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + UPDATE_JOB_TO_FINISHED + '/' + jobId, {});
    }

    public getJobById(dwsmJobId: number): Observable<DWSMJob> {
        return this.httpClient.get<DWSMJob>(environment.baseUrl + globalVar.requestPrefix + DWSM_JOB + GET_JOB_BY_ID + '/' + dwsmJobId);
    }
}
